import React from "react";

import classNames from "classnames";
import { Col, Form, Row } from "react-bootstrap";
import { Controller, useFormContext } from "react-hook-form";
import Select from "react-select";

import { useAppSelector } from "../../../../hooks/reduxHooks";
import { ISiteSettingsForm } from "../../../../types/forms";

const DateSettings = ({
    settingsToShow,
}: {
    settingsToShow: string[];
}): React.JSX.Element | undefined => {
    const settings = useAppSelector(state => state.global.settings);
    const { register, control, setValue, getValues, watch } =
        useFormContext<ISiteSettingsForm>();

    return (
        <section className="dateSettingsContent">
            <Row>
                {settings
                    .filter(s => settingsToShow.includes(s.settingName))
                    .map((s, idx) => {
                        watch(
                            `date.${s.settingName}`,
                            getValues(`date.${s.settingName}`),
                        );
                        return (
                            <Form.Group
                                as={Col}
                                xs={6}
                                md={3}
                                className="col"
                                controlId={s.settingName}
                                key={idx}
                            >
                                <Form.Label className={classNames("mt-0")}>
                                    <h4>{s.displayTitle && s.displayTitle}</h4>
                                </Form.Label>
                                {s.options ? (
                                    <Controller
                                        name={`date.${s.settingName}`}
                                        control={control}
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                isClearable={false}
                                                isSearchable={false}
                                                onChange={value => {
                                                    setValue(
                                                        `date.${s.settingName}`,
                                                        value,
                                                        {
                                                            shouldDirty: true,
                                                        },
                                                    );
                                                }}
                                                options={s.options?.map(
                                                    (o, idx) => ({
                                                        value: idx,
                                                        label: o,
                                                    }),
                                                )}
                                            />
                                        )}
                                    />
                                ) : (
                                    <Form.Control
                                        type="text"
                                        {...register(`date.${s.settingName}`)}
                                        onChange={e => {
                                            setValue(
                                                `date.${s.settingName}`,
                                                e.target.value.toString(),
                                                { shouldDirty: true },
                                            );
                                        }}
                                    />
                                )}
                            </Form.Group>
                        );
                    })}
            </Row>
        </section>
    );
};

export default DateSettings;
